import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediTabList, IncrediTab } from 'incredi-ui';
import { useSettingsTabs } from './SettingsTabs.helpers';
import { SettingsTab } from './SettingsTabs.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsTabs',
  emits: ["change"],
  setup(__props, { emit }: { emit: ({
  (event: 'change', value: SettingsTab['name']): void;
}), expose: any, slots: any, attrs: any }) {

const SettingsTabs = useSettingsTabs();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediTabList), {
        class: "ml-[24px]",
        rounded: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SettingsTabs), (tab, index) => {
            return (_openBlock(), _createBlock(_unref(IncrediTab), _mergeProps({
              key: index,
              index: index,
              active: tab.active,
              class: "!w-[123px]"
            }, tab.attributes, {
              rounded: "",
              onClick: ($event: any) => (emit('change', tab.name))
            }), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(tab?.label), 1)
              ]),
              _: 2
            }, 1040, ["index", "active", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})